
class GrupoTarifario {
    static NenhumGrupo = 0;
    static GrupoA = 1;
    static GrupoB = 2;
    static GrupoBOptante = 3;
}

export default GrupoTarifario;